import vtkElevationReader from './ElevationReader';
import vtkITKImageReader from './ITKImageReader';
import vtkITKPolyDataReader from './ITKPolyDataReader';
import vtkJSONNucleoReader from './JSONNucleoReader';
import vtkJSONReader from './JSONReader';
import vtkMTLReader from './MTLReader';
import vtkOBJReader from './OBJReader';
import vtkPDBReader from './PDBReader';
import vtkSkyboxReader from './SkyboxReader';
import vtkGCodeReader from './GCodeReader';

export default {
  vtkElevationReader,
  vtkITKImageReader,
  vtkITKPolyDataReader,
  vtkJSONNucleoReader,
  vtkJSONReader,
  vtkMTLReader,
  vtkOBJReader,
  vtkPDBReader,
  vtkSkyboxReader,
  vtkGCodeReader,
};
